import placepickerImg from "../assets/images/placepicker.png";
import clothShopImg from "../assets/images/clothing shop.png";
import countdownTimer from "../assets/images/count-down timer.png";
import exerciseTracker from "../assets/images/exercise-tracker.png";
import toDos from "../assets/images/to-dos.png";
import investmentCalculator from "../assets/images/investment-calculator.png";
import tictactoe from "../assets/images/tictactoe.png";
import password_gen from "../assets/images/password_gen.png";
import currency_convertor from "../assets/images/currency-convertor-img.png";
import todos from "../assets/images/todos.png";
import meshop from "../assets/images/meShop.png";
import excelClone from "../assets/images/excelClone.png";
import kanban from "../assets/images/kanban.png";

export const myProjects = [
  {
    title: "Code Bros",
    description: `Trying to Build my Own LeetCode with a twist of gamification. In this website you can solve coding problems and get points for solving them. You can also see the leaderboard and compete with your friends. This is still in development stage and more features will be added soon`,
    images: [
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fcode-bros.png?alt=media&token=29635789-f947-494f-81f0-babfbfa1418d",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fcode-bros1.png?alt=media&token=b00cf285-45e0-4724-983d-9dd1b219881e",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fcode-bros2.png?alt=media&token=e2650f3f-a783-4cb5-94aa-0a355ca3e584",
    ],
    websiteUrl: "https://code-bros.rauchrodrigues.in/",
    githubLink: [
      "https://github.com/rauchrods/code-bros-frontend",
      "https://github.com/rauchrods/code-bros-backend",
    ],
    type: "react",
  },
  {
    title: "Geo Nerd",
    description: `I've always had an immense interest in geography and world maps — the way borders are drawn, how states and districts are shaped, and the stories they tell. Geo Nerd is my way of turning that passion into something playful and interactive.

This project started as a way to test my own knowledge of Indian geography, and hopefully yours too. Whether you're a geography nerd or just curious, I hope you enjoy it!`,
    images: [
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fgeo-nerd.png?alt=media&token=e303bc4d-e099-454e-a5a8-f7d9de613925",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fgeo-nerd1.png?alt=media&token=de5dc7ac-1418-4a2a-baed-14f5f0ee482a",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fgeo-nerd2.png?alt=media&token=fdf6cf4a-00b5-469c-8f87-bd7028f562d7",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fgeo-nerd3.png?alt=media&token=beb77bdb-35a2-4c2a-a0d1-5a8f2d74a42a",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fgeo-nerd4.png?alt=media&token=ddd0007e-88ae-4d87-bb21-243c118b484f",
    ],
    websiteUrl: "https://geo-nerd.rauchrodrigues.in/",
    githubLink: "https://github.com/rauchrods/geo-nerd-client",
    type: "react",
  },
  {
    title: "Apprise Social Media App",
    description: `Launching my social media website Apprise (beta stage) fun project 
You can add posts , like and comment posts get suggested users , follow unfollow them , see their profile , update your profile , see users posts and liked posts in their profile

Techstack: MERN
storage : cloudinary free tier for image storage
Deployment: onRender free tier server

Please test it create , like and comment posts , follow / unfollow users , update your profile

Note : if the website is taking a long time to load please wait onrender free server spins down if there is no requests for long time . Wait for a minute and you are good to go`,
    images: [
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fapprise.png?alt=media&token=85e94921-323e-4979-ba84-0f154ad16ff7",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fapprise1.png?alt=media&token=f306312d-d5e7-4198-811b-c0d51d3a2da2",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fapprise2.png?alt=media&token=e18f74bf-4442-463c-948b-609bd4ee9f20",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fapprise3.png?alt=media&token=462c48c4-997b-4066-89e6-c01cf3058b59",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fapprise4.png?alt=media&token=871b64ce-4877-4181-bd2c-5fcad523381c",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fapprise5.png?alt=media&token=366abc83-cba1-4416-a522-9c7913a4b204",
    ],
    websiteUrl: "https://apprise.rauchrodrigues.in/",
    githubLink: "https://github.com/rauchrods/Apprise-Social-Media",
    type: "react",
  },
  {
    title: "Sticky Notes App",
    description:
      "A simple sticky notes app inspired from  colorfull post it notes which allows you to create, edit and delete notes. Upo can create multiple sticky notes of any color of your choice and place it anywhere on the board.",
    images: [
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2FStickyNotes.png?alt=media&token=07a33bf1-917b-40a7-94e6-26a13959a8d0",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2FStickyNotes1.png?alt=media&token=220d43c4-4ebb-4bf0-bcfc-9d74676563d1",
    ],
    websiteUrl: "https://sticky-notes.rauchrodrigues.in/",
    githubLink: "https://github.com/rauchrods/Sticky-Notes",
    type: "react",
  },
  {
    title: "Movies IMDB App",
    description: `Similar to IMDB this app displays all the popular movies at the current time.
    Thanks to the free apis provided by TMDB which has millions of movie collections. This also has search functionality so that you can get details of any movie as you search.
    You also get trending movies based on the searches you make. This is made possible due to database made in appwrite`,
    images: [
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fnot-imdb-1.png?alt=media&token=e548ad12-26e9-413f-85a5-c8f9bf1b38b5",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fnot-imdb-2.png?alt=media&token=146264e5-c30c-435d-a20a-a916855e0aa6",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fnot-imdb-3.png?alt=media&token=8782f7ea-b59a-4145-8d78-ebcf441e1fae",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fnot-imdb-4.png?alt=media&token=206ac84e-9673-4947-8952-a2d9e4d51348",
    ],
    websiteUrl: "https://not-imdb.rauchrodrigues.in/",
    githubLink: "https://github.com/rauchrods/NotIMDB",
    type: "react",
  },
  {
    title: "BookStore MERN Project",
    description:
      "This is an initiative to create a centralised book library where users can add, update and delete books. you just need to provide the pdf url link uploaded in some cloud like googlecloud etc. Once added your book will be available to all the viewers",
    images: [
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fbook_store.png?alt=media&token=da2dc058-c1e9-44cd-9d0d-2c1204c977f4",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fbookstoall2.png?alt=media&token=5d3cdea9-ea2e-493f-ba43-60e9a7489e1a",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fbookstoall3.png?alt=media&token=6003d24c-8053-4366-98d5-7af21f17be7c",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fbookstoall4.png?alt=media&token=df192479-33af-4ef0-8589-2580c3881194",
    ],
    websiteUrl: "https://bookstoall.vercel.app/",
    githubLink: "https://github.com/rauchrods/BooksForAll",
    type: "react",
  },
  {
    title: "mini_projects",
    description:
      "website which consists a lot of mini projects. These projects clears the basic react concepts useState, useEffect, customHooks etc.",
    images: [
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fmini-projects.png?alt=media&token=b6650f22-2192-4f26-8a83-18710d5ab5f6",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fminiproj1.png?alt=media&token=f345f0e3-0062-496b-abc2-daab9f16c3be",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fminiproj2.png?alt=media&token=5bf56256-1e10-47c5-8aa8-28ba18289bd4",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fminiproj3.png?alt=media&token=1114a8c7-c2f2-4535-9fd3-96376dcca1c7",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fminiproj4.png?alt=media&token=fac40dbe-be72-4aba-9e12-3db794c4ecf6",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fminiproj6.png?alt=media&token=a40a8551-44aa-4bd8-b1ae-8ff610e24bf5",
    ],
    websiteUrl: "https://miniprojects-rauchrodrigues.netlify.app/",
    githubLink: "https://github.com/rauchrods/mini_projects",
    type: "react",
  },
  {
    title: "To-Dos App",
    description:
      "To-Dos application which allows you to add to do in the list and also provides you with editing , finishing and deleting the task.The todos are also saved in the local storage so when the website is reloaded the data is not lost",
    images: [todos],
    websiteUrl: "https://todos-rauch.netlify.app/",
    githubLink: "https://github.com/rauchrods/todos-react",
    type: "react",
  },
  {
    title: "Currency Converter",
    description:
      "currency converter between all the available currency type options in the world",
    images: [currency_convertor],
    websiteUrl: "https://currency-converte-rauch.netlify.app/",
    githubLink: "https://github.com/rauchrods/currency-convertor",
    type: "react",
  },

  {
    title: "Random-Meme-Generator",
    description:
      "A web page which generates random meme images which are trending. It uses a free open source api to fetch those memes.",
    images: [
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fmeme-generator.png?alt=media&token=b482c009-579a-4361-baeb-3bd48ab53f35",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fmeme-gen-1.png?alt=media&token=b71df668-373f-45b4-b350-3d028859ce31",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fmeme-gen-2.png?alt=media&token=7cb0f022-9edf-4db8-a59d-47bf07cabfc4",
      "https://firebasestorage.googleapis.com/v0/b/socializeme-be1f4.appspot.com/o/Project%20Images%2Fmeme-gen-3.png?alt=media&token=85ac0d8c-10d6-47c4-baac-b6bfb16f125f",
    ],
    websiteUrl: "https://meme-generator-rauch.netlify.app/",
    githubLink: "https://github.com/rauchrods/Meme-Generator",
    type: "react",
  },

  {
    title: "Password-Generator",
    description: "Random password generator which has basic filters",
    images: [password_gen],
    websiteUrl: "https://password-generator-rauch.netlify.app",
    githubLink: "https://github.com/rauchrods/password-generator-react",
    type: "react",
  },
  {
    title: "Place Picker",
    description:
      "This websites displays a wide array of beautiful destination places which you can select and add it to your list. This will be saved next time you visit again the places are also sorted based on your geo location",
    images: [placepickerImg],
    websiteUrl: "https://place-picker-rauch.netlify.app/",
    githubLink: "https://github.com/rauchrods/Place-Picker",
    type: "react",
  },
  {
    title: "Count Down Game",
    description:
      "this website displays different level-wise count down challenges where you have to stop the time as close to the timer if you exceed the time u are disqualified. Final score will be displayed",
    images: [countdownTimer],
    websiteUrl: "https://countdown-game-rauch.netlify.app/",
    githubLink: "https://github.com/rauchrods/count-down-game",
    type: "react",
  },

  {
    title: "Exercise Tracker",
    description:
      "This website is made with MERN stack where we can add users and then we can add exercises for the users present in the database. also u can do basic CRUD operation on these exercises and users",
    images: [exerciseTracker],
    websiteUrl: "",
    githubLink: "https://github.com/rauchrods/exercise-tracker",
    type: "react",
  },
  {
    title: "To-Dos",
    description:
      "In this website you can add to do event and then view the details and also add tasks to that particular event and delete the to-do event",
    images: [toDos],
    websiteUrl: "https://to-dos-rauch.netlify.app/",
    githubLink: "https://github.com/rauchrods/to-dos",
    type: "react",
  },
  {
    title: "Investment Calculator",
    description:
      "In this website you get a breakdown of your investment return based on the input form ",
    images: [investmentCalculator],
    websiteUrl: "https://investment-calculator-rauch.netlify.app/",
    githubLink: "https://github.com/rauchrods/investment-calculator",
    type: "react",
  },
  {
    title: "Tic Tac Toe",
    description: "you can play tic tac toe game",
    images: [tictactoe],
    websiteUrl: "https://tic-tact-toe-rauch.netlify.app/",
    githubLink: "https://github.com/rauchrods/tic-tac-toe",
    type: "react",
  },
  {
    title: "Clothing Shop",
    description:
      "This websites displays a wide array of beautiful clothing apparels which you can select and add in cart. you can go to the cart and update the quantities from there as well",
    images: [clothShopImg],
    websiteUrl: "https://cloth-shop-rauch.netlify.app/",
    githubLink: "https://github.com/rauchrods/cloth-shop",
    type: "react",
  },

  {
    title: "ME-Shop (shopping website)",
    description: `Shopping website which have features such as sign-up, login, my-profile section, homepage, cart section
       on sign-up it stores the users details and can be logged in later anytime by storing users in browser local storage
       Saved user details can be edited in my-profile section. Products are fetched through an API these products can be
      filtered based on rating and price. It can be added and removed from cart as well.
      Added products are saved in cart and can be checked-out buy razor-pay payment session`,
    images: [meshop],
    websiteUrl: "https://rauchrods.github.io/Me-Shop-shopping-Site/",
    githubLink: "https://github.com/rauchrods/Me-Shop-shopping-Site",
    type: "vanila",
  },

  {
    title: "Excel Clone",
    description: `Responsive UI of excel clone Designed and created using HTML CSS (FlexBox) for all device compatibility
       100 rows by 26 column grid/ cells is created which can be used to do major operations like text and styling
       Multiple sheets can be added for the same file each of 100*26 grid cells
       Upload and download feature is also provided
       Also Local storage is implemented i.e cells used will be saved in the browser local storage and when sheets are
      reloaded the data is not lost`,
    images: [excelClone],
    websiteUrl: "https://rauchrods.github.io/Excel-Clone/",
    githubLink: "https://github.com/rauchrods/Excel-Clone",
    type: "vanila",
  },

  {
    title: "Kanban Task Management website",
    description: `Responsive UI Designed and created using HTML CSS (FlexBox and Media Query) for all device compatibility
      Tasks can be created and CRUD Operations can be performed on Tasks
      Tasks are segregated based on the priority which makes it intuitive to use
      Search bar is also Implemented to quickly filter out searched tasks
      Also Local storage is implemented i.e Tasks created will be saved in the browser local storage and when page is
      reloaded the data is not lost`,
    images: [kanban],
    websiteUrl:
      "https://rauchrods.github.io/My-Jira-kanban-Task-Management-System/",
    githubLink:
      "https://github.com/rauchrods/My-Jira-kanban-Task-Management-System",
    type: "vanila",
  },
];

myProjects.forEach((project, index) => {
  project.id = `${project.type}-${index + 1}`;
});
